import { lazy, Suspense } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./components/protectedRoute";
import { PageRoutes } from "./enums/routes.enum";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Loading from "@/components/loading";
import { useAuth } from "./hooks/auth";
import { checkMatch } from "./utils";
import { useFeedback } from "@/context/FeedbackContext";
import FeedbackPopup from "@/components/FeedbackPopup";
import GuestRoute from "./guards/GuestRoute";
import AuthStandaloneRoute from "./guards/AuthStandaloneRoute";
import { Unauthorized } from "./components/unauthorized";


//import {useNotification} from "./hooks/useNotification";
// import { NotificationProvider } from "@/context/notification";
// import { socketService } from './api';

// import EnrollmentV5 from "@/@/pages/enrollment_v5";
// import Enrollmentv5 from "@/@/pages/enrollment_v5/enrollmentvv5";
// import EnrollmentV5Index from "@/@/pages/enrollment_v5";
// import EnrollmentFormv5 from "@/@/pages/enrollment_v5/forms";
const Home = lazy(() => import("@/pages/home"))

const NotFound = lazy(() => import("@/pages/notFound"))
const Dashboard = lazy(() => import("@/pages/dashboard"))
const Application = lazy(() => import("@/pages/forms/application/application"))
const ApplicationIndex = lazy(() => import("@/pages/forms/application"))
const ApplicationForm = lazy(() => import("@/pages/forms/application/form"))
const NewApplication = lazy(() => import("@/pages/forms/application/new"))

//Role
const Roles = lazy(() => import("@/pages/role-permission/index"));
const RolePermissionSettings = lazy(() => import("@/pages/role-permission/permissionSetting"));
// const UpdateRoleForm = lazy(() => import("@/pages/role-permission/updateRoleForm"));

// tickets
const TicketIndex = lazy(() => import("@/pages/tickets/TicketIndex"));
const Tickets = lazy(() => import("@/pages/tickets"));

const TicketDetail = lazy(() => import("@/pages/tickets/detail"));
//chat
const ChatDashboard = lazy(() => import("@/components/Chat/ChatDashboard"));
const ChatBox = lazy(() => import("@/components/Chat/chatbox"));
const GuestChatBox = lazy(() => import("@/components/Chat/GuestChatBox"));
const ChatIndex = lazy(() => import("@/components/Chat/ChatIndex"));

const EnrollmentIndex = lazy(() => import("@/pages/forms/new_enrollment_v5"));
const Enrollment = lazy(() => import("@/pages/forms/new_enrollment_v5/enrollment"));
const NewEnrollment = lazy(() => import("@/pages/forms/new_enrollment_v5/new"));
const EditEnrollment = lazy(() => import("@/pages/forms/new_enrollment_v5/edit"));
const EnrollmentForm = lazy(() => import("@/pages/forms/new_enrollment_v5/form"));
const EnrollmentFormDetails = lazy(() => import("@/pages/forms/new_enrollment_v5/detail"));
//Re Enrollment Form Part
const ReEnrollmentIndex = lazy(() => import("@/pages/forms/reEnrollmentForm"));
const ReEnrollment = lazy(() => import("@/pages/forms/reEnrollmentForm/reenrollment"));
const ReEnrollmentWelcome = lazy(() => import("@/pages/forms/reEnrollmentForm/welcome"));
const NewReEnrollmentForm = lazy(() => import("@/pages/forms/reEnrollmentForm/form"));
const EditReEnrollmentForm = lazy(() => import("@/pages/forms/reEnrollmentForm/edit"))
const ReEnrollmentFormDetails = lazy(() => import("@/pages/forms/reEnrollmentForm/detail"))

const ChangeOfAddressIndex = lazy(() => import("@/pages/forms/changeOfAddress"));
const ChangeOfAddress = lazy(() => import("@/pages/forms/changeOfAddress/changeOfAddress"));
const NewChangeOfAddressForm = lazy(() => import("@/pages/forms/changeOfAddress/form"));
const EditChangeOfAddressForm = lazy(() => import("@/pages/forms/changeOfAddress/edit"))
const ChangeOfAddressFormDetails = lazy(() => import("@/pages/forms/changeOfAddress/detail"));

const VariationOfCourseIndex = lazy(() => import("@/pages/forms/variationOfCourse"));
const VariationOfCourse = lazy(() => import("@/pages/forms/variationOfCourse/variationOfCourse"));
const NewVariationOfCourseForm = lazy(() => import("@/pages/forms/variationOfCourse/form"));
const EditVariationOfCourseForm = lazy(() => import("@/pages/forms/variationOfCourse/edit"))
const VariationOfCourseFormDetails = lazy(() => import("@/pages/forms/variationOfCourse/detail"));

const InternalTransferIndex = lazy(() => import("@/pages/forms/internalTransfer"));
const InternalTransfer = lazy(() => import("@/pages/forms/internalTransfer/internalTransfer"));
const NewInternalTransferForm = lazy(() => import("@/pages/forms/internalTransfer/form"));
const EditInternalTransferForm = lazy(() => import("@/pages/forms/internalTransfer/edit"))
const InternalTransferFormDetails = lazy(() => import("@/pages/forms/internalTransfer/detail"));

const StudentInterventionIndex = lazy(() => import("@/pages/forms/studentIntervention"));
const StudentIntervention = lazy(() => import("@/pages/forms/studentIntervention/studentIntervention"));
const NewStudentInterventionForm = lazy(() => import("@/pages/forms/studentIntervention/form"));
const EditStudentInterventionForm = lazy(() => import("@/pages/forms/studentIntervention/edit"))
const StudentInterventionDetails = lazy(() => import("@/pages/forms/studentIntervention/detail"));

const RequestOfInformationIndex = lazy(() => import("@/pages/forms/requestOfInformation"));
const RequestOfInformation = lazy(() => import("@/pages/forms/requestOfInformation/requestOfInformation"));
const NewRequestOfInformationForm = lazy(() => import("@/pages/forms/requestOfInformation/form"));
const EditRequestOfInformationForm = lazy(() => import("@/pages/forms/requestOfInformation/edit"))
const RequestOfInformationDetails = lazy(() => import("@/pages/forms/requestOfInformation/detail"));

const CreditTransferIndex = lazy(() => import("@/pages/forms/creditTransfer"));
const CreditTransfer = lazy(() => import("@/pages/forms/creditTransfer/creditTransfer"));
const NewCreditTransferForm = lazy(() => import("@/pages/forms/creditTransfer/form"));
const EditCreditTransferForm = lazy(() => import("@/pages/forms/creditTransfer/edit"))
const CreditTransferDetails = lazy(() => import("@/pages/forms/creditTransfer/detail"));

const DSRCEnrolmentIndex = lazy(() => import("@/pages/forms/applicationToDSRCEnrolment"));
const DSRCEnrolment = lazy(() => import("@/pages/forms/applicationToDSRCEnrolment/dsrcEnrolment"));
const NewDSRCEnrolmentForm = lazy(() => import("@/pages/forms/applicationToDSRCEnrolment/form"));
const EditDSRCEnrolmentForm = lazy(() => import("@/pages/forms/applicationToDSRCEnrolment/edit"))
const DSRCEnrolmentDetails = lazy(() => import("@/pages/forms/applicationToDSRCEnrolment/detail"));

const OverseasTravelIndex = lazy(() => import("@/pages/forms/overseasTravel"));
const OverseasTravel = lazy(() => import("@/pages/forms/overseasTravel/overseasTravel"));
const NewOverseasTravelForm = lazy(() => import("@/pages/forms/overseasTravel/form"));
const EditOverseasTravelForm = lazy(() => import("@/pages/forms/overseasTravel/edit"))
const OverseasTravelDetails = lazy(() => import("@/pages/forms/overseasTravel/detail"));

const CertificateApplicationIndex = lazy(() => import("@/pages/forms/certificateApplication"));
const CertificateApplication = lazy(() => import("@/pages/forms/certificateApplication/certificateApplication"));
const NewCertificateApplicationForm = lazy(() => import("@/pages/forms/certificateApplication/form"));
const EditCertificateApplicationForm = lazy(() => import("@/pages/forms/certificateApplication/edit"))
const CertificateApplicationDetails = lazy(() => import("@/pages/forms/certificateApplication/detail"));

const ComplaintsAppealsIndex = lazy(() => import("@/pages/forms/complaintsAppeals"));
const ComplaintsAppeals = lazy(() => import("@/pages/forms/complaintsAppeals/complaintsAppeals"));
const NewComplaintsAppealsForm = lazy(() => import("@/pages/forms/complaintsAppeals/form"));
const EditComplaintsAppealsForm = lazy(() => import("@/pages/forms/complaintsAppeals/edit"))
const ComplaintsAppealsDetails = lazy(() => import("@/pages/forms/complaintsAppeals/detail"));

// const EnrollmentIndex = lazy(() => import("@/pages/enrollment"))
// const Enrollment = lazy(() => import("@/pages/enrollment/enrollment"))
// const EnrollmentForm = lazy(() => import("@/pages/enrollment/form"))
// const NewEnrollment = lazy(() => import("@/pages/enrollment/new"))
// const EnrollmentFormDetails = lazy(() => import("@/pages/enrollment/detail"))
// const EditEnrollment = lazy(() => import("@/pages/enrollment/edit"))

const ApplicationFormDetails = lazy(() => import("@/pages/forms/application/detail"))
const EditApplication = lazy(() => import("@/pages/forms/application/edit"))
const Layout = lazy(() => import("@/pages/layout"))
const Courses = lazy(() => import("@/pages/courses/index"))
const Users = lazy(() => import('@/pages/users'))
const Login = lazy(() => import('@/pages/login'))
const CourseIndex = lazy(() => import("@/pages/courses/CourseIndex"));

const Registration = lazy(() => import("@/pages/registration"))
const MailVerification = lazy(() => import("@/pages/mail_verification/verify_mail"))
const SetPassword = lazy(() => import("@/pages/set_password"))
const ResetPassword = lazy(() => import("@/pages/reset_password/reset_password"))
const ForgotPassword = lazy(() => import("@/pages/reset_password"))
const UserProfile = lazy(() => import("@/pages/user/user_profile"))
const UpdateUsers = lazy(() => import("@/pages/user/update"))
// const AddNewUser = lazy(() => import("@/pages/user/addNewUser"))
const UserIndex = lazy(() => import("@/pages/users/UserIndex"));
const ChangeUserPassword = lazy(() => import("@/pages/user/change_user_password"))

const NewCourse = lazy(() => import("@/pages/courses/new_course"))
const UpdateCourse = lazy(() => import("@/pages/courses/update"))
const ShortCourses = lazy(() => import('@/pages/shortCourses'))
const ShortCoursePdf = lazy(() => import("@/pages/shortCourses/order/shortCoursePdf"))
const ShortCourseBook = lazy(() => import("@/pages/home/shortCourseBook")) //for home page booking
const ShortCoursesBook = lazy(() => import("@/pages/shortCourses/book"))
const ShortCoursesOrder = lazy(() => import("@/pages/shortCourses/order"));
const ShortCourseOrderDetail = lazy(() => import("@/pages/shortCourses/order/shortCourseOrderDetail"));
const ShortCourseIndex = lazy(() => import("@/pages/shortCourses/ShortCourseIndex"));
const ShortCourseOrderIndex = lazy(() => import("@/pages/shortCourses/order/ShortCourseOrderIndex"));

const PurchaseOrder = lazy(() => import('@/pages/inventories/PurchaseOrder'));
const InventoriesPage = lazy(() => import('@/pages/inventories/Inventories'));
const CreateInventoryPage = lazy(() => import('@/pages/inventories/CreateInventory'));
const InventoryDisposePage = lazy(() => import('@/pages/inventories/InventoryDispose'));
const AssignInventoryPage = lazy(() => import('@/pages/inventories/AssignInventory'));
const CreatePurchaseOrder = lazy(() => import('@/pages/inventories/CreatePurchaseOrder'));
const EditPurchaseOrder = lazy(() => import('@/pages/inventories/EditPurchaseOrder'));
const PurchaseOrderDetail = lazy(() => import('@/pages/inventories/PurchaseOrderDetail'));
// const AppliedShortCourses = lazy(() => import('pages/appliedShortCoursesOrder'))
// const ShortCourseOrders = lazy(() => import('pages/shortCourseOrders'))

// const AppliedShortCourseDocuments = lazy(() => import("@/pages/shortCourseOrders/documents"))
// const PayNow = lazy(() => import("@/pages/appliedShortCoursesOrder/pay"))


const GoogleCallback = lazy(() => import("@/pages/auth/GoogleCallback"))
const FeedbackPage = lazy(() => import("@/pages/feedback"))
const DocumentTypes = lazy(() => import("@/pages/documentTypes/index"))
const DocumentReport = lazy(() => import("@/pages/documentReport"))
const NoteCategoriesPage = lazy(() => import("@/pages/noteCategories/index"))
const DocumentTypeIndex = lazy(() => import("@/pages/documentTypes/DocumentTypeIndex"))
const Settings = lazy(() => import("@/pages/settings"))
const InventoryItemOverview = lazy(() => import('@/pages/inventories/InventoryItemOverview'));


function App() {
    const { roles, permissions, isAuthenticated }: any = useAuth()
    const { isOpen: feedbackOpen, formType: feedbackFormType, closeFeedback } = useFeedback()



    const routes = [
        {
            path: PageRoutes.DASHBOARD,
            element: <Dashboard />,
            role: ['Superadmin', 'Agent', 'Student', 'Admin'],
            permissions: []
        },
        { path: PageRoutes.PURCHASE_ORDER, element: <PurchaseOrder />, role: [], permissions: [] },
        { path: PageRoutes.PROFILE, element: <UserProfile />, role: [], permissions: [] },
        { path: PageRoutes.USERS, element: <Users />, role: ['Superadmin'], permissions: ['menu-user', 'list-user'] },
        // { path: PageRoutes.UPDATEUSERS, element: <UpdateUsers />, role: ['Superadmin'], permissions: ['show-user'] },
        { path: PageRoutes.PASSWORDCHANGE, element: <ChangeUserPassword />, role: ['Superadmin'], permissions: ['update-user'] },

        { path: PageRoutes.COURSES, element: <Courses />, role: ['Superadmin'], permissions: ['menu-course', 'list-course'] },
        { path: PageRoutes.NEWCOURSE, element: <NewCourse />, role: ['Superadmin'], permissions: ['create-course'] },
        { path: PageRoutes.UPDATECOURSE, element: <UpdateCourse />, role: ['Superadmin'], permissions: ['update-course'] },

        { path: PageRoutes.ROLES, element: <Roles />, role: ['Superadmin'], permissions: [] },
        // { path: "/roles/edit/:id", element: <UpdateRoleForm />, role: ['Superadmin'], permissions: [''] },

        { path: PageRoutes.PERMISSIONSETTINGS, element: <RolePermissionSettings />, role: ['Superadmin'], permissions: [] },
        { path: "/chat", element: <ChatDashboard />, role: ['Superadmin'], permissions: ['menu-chat'] },
        { path: PageRoutes.SHORTCOURSES, element: <ShortCourses />, role: ['Superadmin'], permissions: ['menu-short-course', 'list-short-course'] },
        { path: PageRoutes.SHORTCOURSESBOOK, element: <ShortCoursesBook />, role: ['Superadmin'], permissions: ['list-short-course-book'] },
        { path: PageRoutes.SHORTCOURSESORDER, element: <ShortCoursesOrder />, role: ['Superadmin'], permissions: ['menu-short-course-order', 'list-short-course-order'] },
        { path: PageRoutes.SHORTCOURSEORDERDETAIL, element: <ShortCourseOrderDetail />, role: ['Superadmin'], permissions: ['show-short-course-order'] },
        { path: PageRoutes.SHORTCOURSEORDERPDF, element: <ShortCoursePdf />, role: ['Superadmin'], permissions: ['download-short-course-order-pdf'] },

        // Application Form Routes
        { path: PageRoutes.APPLICATION, element: <Application />, role: ['Superadmin'], permissions: ['menu-application-form', 'list-application-form'] },
        { path: `${PageRoutes.APPLICATION}/new`, element: <NewApplication />, role: ['Superadmin'], permissions: ['create-application-form'] },
        { path: `${PageRoutes.APPLICATION}/:id`, element: <ApplicationFormDetails />, role: ['Superadmin'], permissions: ['show-application-form'] },
        { path: `${PageRoutes.APPLICATION}/:id/edit`, element: <EditApplication />, role: ['Superadmin'], permissions: ['update-application-form'] },

        // Enrollment Form Routes  
        { path: PageRoutes.ENROLLMENT, element: <Enrollment />, role: ['Superadmin'], permissions: ['menu-enrollment-form', 'list-enrollment-form'] },
        { path: `${PageRoutes.ENROLLMENT}/new`, element: <NewEnrollment />, role: ['Superadmin'], permissions: ['create-enrollment-form'] },
        { path: `${PageRoutes.ENROLLMENT}/:id`, element: <EnrollmentFormDetails />, role: ['Superadmin'], permissions: ['show-enrollment-form'] },
        { path: `${PageRoutes.ENROLLMENT}/:id/edit`, element: <EditEnrollment />, role: ['Superadmin'], permissions: ['update-enrollment-form'] },

        //variation of course form
        {
            path: PageRoutes.VARIATIONOFCOURSE,
            element: <VariationOfCourse />,
            role: ['Superadmin'],
            permissions: ['menu-variation-form', 'list-variation-form']
        },
        {
            path: `${PageRoutes.VARIATIONOFCOURSE}/new`,
            element: <NewVariationOfCourseForm />,
            role: ['Superadmin'],
            permissions: ['create-variation-form']
        },
        {
            path: `${PageRoutes.VARIATIONOFCOURSE}/:id`,
            element: <VariationOfCourseFormDetails />,
            role: ['Superadmin'],
            permissions: ['show-variation-form']
        },
        {
            path: `${PageRoutes.VARIATIONOFCOURSE}/:id/edit`,
            element: <EditVariationOfCourseForm />,
            role: ['Superadmin'],
            permissions: ['update-variation-form']
        },
        //reenrollment form
        {
            path: PageRoutes.REENROLLMENT,
            element: <ReEnrollment />,
            role: ['Superadmin'],
            permissions: ['menu-reenrollment-form', 'list-reenrollment-form']
        },
        {
            path: `${PageRoutes.REENROLLMENT}/new`,
            element: <ReEnrollmentWelcome />,
            role: ['Superadmin'],
            permissions: ['create-reenrollment-form']
        },
        {
            path: `${PageRoutes.REENROLLMENT}/:id`,
            element: <ReEnrollmentFormDetails />,
            role: ['Superadmin'],
            permissions: ['show-reenrollment-form']
        },
        {
            path: `${PageRoutes.REENROLLMENT}/:id/edit`,
            element: <EditReEnrollmentForm />,
            role: ['Superadmin'],
            permissions: ['update-reenrollment-form']
        },

        //change of address form 
        {
            path: PageRoutes.CHANGEOFADDRESS,
            element: <ChangeOfAddress />,
            role: ['Superadmin'],
            permissions: ['menu-change-of-address-form', 'list-change-of-address-form']
        },
        {
            path: `${PageRoutes.CHANGEOFADDRESS}/new`,
            element: <NewChangeOfAddressForm />,
            role: ['Superadmin'],
            permissions: ['create-change-of-address-form']
        },
        {
            path: `${PageRoutes.CHANGEOFADDRESS}/:id`,
            element: <ChangeOfAddressFormDetails />,
            role: ['Superadmin'],
            permissions: ['show-change-of-address-form']
        },
        {
            path: `${PageRoutes.CHANGEOFADDRESS}/:id/edit`,
            element: <EditChangeOfAddressForm />,
            role: ['Superadmin'],
            permissions: ['update-change-of-address-form']
        },

        //defer form        
        {
            path: PageRoutes.DSRCENROLMENT,
            element: <DSRCEnrolment />,
            role: ['Superadmin'],
            permissions: ['menu-defer-form', 'list-defer-form']
        },
        {
            path: `${PageRoutes.DSRCENROLMENT}/new`,
            element: <NewDSRCEnrolmentForm />,
            role: ['Superadmin'],
            permissions: ['create-defer-form']
        },
        {
            path: `${PageRoutes.DSRCENROLMENT}/:id`,
            element: <DSRCEnrolmentDetails />,
            role: ['Superadmin'],
            permissions: ['show-defer-form']
        },
        {
            path: `${PageRoutes.DSRCENROLMENT}/:id/edit`,
            element: <EditDSRCEnrolmentForm />,
            role: ['Superadmin'],
            permissions: ['update-defer-form']
        },
        //overseas travel form
        {
            path: PageRoutes.OVERSEASTRAVEL,
            element: <OverseasTravel />,
            role: ['Superadmin'],
            permissions: ['menu-overseas-form', 'list-overseas-form']
        },
        {
            path: `${PageRoutes.OVERSEASTRAVEL}/new`,
            element: <NewOverseasTravelForm />,
            role: ['Superadmin', 'Admin'],
            permissions: ['create-overseas-form']
        },
        {
            path: `${PageRoutes.OVERSEASTRAVEL}/:id`,
            element: <OverseasTravelDetails />,
            role: ['Superadmin'],
            permissions: ['show-overseas-form']
        },
        {
            path: `${PageRoutes.OVERSEASTRAVEL}/:id/edit`,
            element: <EditOverseasTravelForm />,
            role: ['Superadmin'],
            permissions: ['update-overseas-form']
        },

        //internal transfer form
        {
            path: PageRoutes.INTERNALTRANSFER,
            element: <InternalTransfer />,
            role: ['Superadmin'],
            permissions: ['menu-internal-transfer-form', 'list-transfer-form']
        },
        {
            path: `${PageRoutes.INTERNALTRANSFER}/new`,
            element: <NewInternalTransferForm />,
            role: ['Superadmin'],
            permissions: ['create-internal-transfer-form']
        },
        {
            path: `${PageRoutes.INTERNALTRANSFER}/:id`,
            element: <InternalTransferFormDetails />,
            role: ['Superadmin'],
            permissions: ['show-internal-transfer-form']
        },
        {
            path: `${PageRoutes.INTERNALTRANSFER}/:id/edit`,
            element: <EditInternalTransferForm />,
            role: ['Superadmin'],
            permissions: ['update-internal-transfer-form']
        },

        //credit transfer
        {
            path: PageRoutes.CREDITTRANSFER,
            element: <CreditTransfer />,
            role: ['Superadmin'],
            permissions: ['menu-credit-transfer-form', 'list-credit-transfer-form']
        },
        {
            path: `${PageRoutes.CREDITTRANSFER}/new`,
            element: <NewCreditTransferForm />,
            role: ['Superadmin'],
            permissions: ['create-credit-transfer-form']
        },
        {
            path: `${PageRoutes.CREDITTRANSFER}/:id`,
            element: <CreditTransferDetails />,
            role: ['Superadmin'],
            permissions: ['show-credit-transfer-form']
        },
        {
            path: `${PageRoutes.CREDITTRANSFER}/:id/edit`,
            element: <EditCreditTransferForm />,
            role: ['Superadmin'],
            permissions: ['update-credit-transfer-form']
        },
        //request of information
        {
            path: PageRoutes.REQUESTOFINFORMATION,
            element: <RequestOfInformation />,
            role: ['Superadmin'],
            permissions: ['menu-request-of-information-form', 'list-request-of-information-form']
        },
        {
            path: `${PageRoutes.REQUESTOFINFORMATION}/new`,
            element: <NewRequestOfInformationForm />,
            role: ['Superadmin'],
            permissions: ['create-request-of-information-form']
        },
        {
            path: `${PageRoutes.REQUESTOFINFORMATION}/:id`,
            element: <RequestOfInformationDetails />,
            role: ['Superadmin'],
            permissions: ['show-request-of-information-form']
        },
        {
            path: `${PageRoutes.REQUESTOFINFORMATION}/:id/edit`,
            element: <EditRequestOfInformationForm />,
            role: ['Superadmin'],
            permissions: ['update-request-of-information-form']
        },

        //student intervention
        {
            path: PageRoutes.STUDENTINTERVENTION,
            element: <StudentIntervention />,
            role: ['Superadmin'],
            permissions: ['menu-student-intervention-form', 'list-student-intervention-form']
        },
        {
            path: `${PageRoutes.STUDENTINTERVENTION}/new`,
            element: <NewStudentInterventionForm />,
            role: ['Superadmin'],
            permissions: ['create-student-intervention-form']
        },
        {
            path: `${PageRoutes.STUDENTINTERVENTION}/:id`,
            element: <StudentInterventionDetails />,
            role: ['Superadmin'],
            permissions: ['show-student-intervention-form']
        },
        {
            path: `${PageRoutes.STUDENTINTERVENTION}/:id/edit`,
            element: <EditStudentInterventionForm />,
            role: ['Superadmin'],
            permissions: ['update-student-intervention-form']
        },

        //certificate application
        {
            path: PageRoutes.CERTIFICATEAPPLICATION,
            element: <CertificateApplication />,
            role: ['Superadmin'],
            permissions: ['menu-certificate-application-form', 'list-certificate-application-form']
        },
        {
            path: `${PageRoutes.CERTIFICATEAPPLICATION}/new`,
            element: <NewCertificateApplicationForm />,
            role: ['Superadmin'],
            permissions: ['create-certificate-application-form']
        },
        {
            path: `${PageRoutes.CERTIFICATEAPPLICATION}/:id`,
            element: <CertificateApplicationDetails />,
            role: ['Superadmin'],
            permissions: ['show-certificate-application-form']
        },
        {
            path: `${PageRoutes.CERTIFICATEAPPLICATION}/:id/edit`,
            element: <EditCertificateApplicationForm />,
            role: ['Superadmin'],
            permissions: ['update-certificate-application-form']
        },
        //compaint and appeal form
        {
            path: PageRoutes.COMPLAINTSAPPEALS,
            element: <ComplaintsAppeals />,
            role: ['Superadmin'],
            permissions: ['menu-complaints-appeals-form', 'list-complaints-appeals-form']
        },
        {
            path: `${PageRoutes.COMPLAINTSAPPEALS}/new`,
            element: <NewComplaintsAppealsForm />,
            role: ['Superadmin'],
            permissions: ['create-complaints-appeals-form']
        },
        {
            path: `${PageRoutes.COMPLAINTSAPPEALS}/:id`,
            element: <ComplaintsAppealsDetails />,
            role: ['Superadmin'],
            permissions: ['show-complaints-appeals-form']
        },
        {
            path: `${PageRoutes.COMPLAINTSAPPEALS}/:id/edit`,
            element: <EditComplaintsAppealsForm />,
            role: ['Superadmin'],
            permissions: ['update-complaints-appeals-form']
        },

        // Feedback
        {
            path: PageRoutes.FEEDBACK,
            element: <FeedbackPage />,
            role: ['Superadmin'],
            permissions: ['menu-feedback']
        },
        {
            path: PageRoutes.DOCUMENTREPORT,
            element: <DocumentReport />,
            role: ['Superadmin'],
            permissions: ['menu-document-report']
        },
        // Document Types
        {
            path: PageRoutes.DOCUMENTTYPES,
            element: <DocumentTypes />,
            role: ['Superadmin'],
            permissions: ['menu-document-type', 'list-document-type']
        },
        {
            path: PageRoutes.NOTECATEGORIES,
            element: <NoteCategoriesPage />,
            role: ['Superadmin'],
            permissions: ['menu-note-category', 'list-note-category']
        },
        // Settings
        {
            path: PageRoutes.SETTINGS,
            element: <Settings />,
            role: ['Superadmin'],
            permissions: ['menu-settings'],
        },

    ];

    return (
        <div className='h-screen'>
            <Suspense fallback={<Loading />}>
                <Routes>
                    <Route path='*' element={<NotFound />} />
                    <Route path={PageRoutes.HOME} element={<Home />} />
                    <Route path={PageRoutes.SHORTCOURSEBOOK} element={<ShortCourseBook />} />
                    <Route element={<GuestRoute />}>
                        <Route path={PageRoutes.LOGIN} element={<Login />} />
                        <Route path={PageRoutes.REGISTER} element={<Registration />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/email/verify/:id/:verification_token" element={<MailVerification />} />
                        <Route path="/auth/google/callback" element={<GoogleCallback />} />
                    </Route>
                    <Route element={<AuthStandaloneRoute />}>
                        <Route path={PageRoutes.SET_PASSWORD} element={<SetPassword />} />
                    </Route>
                    <Route
                        path='/'
                        element={<ProtectedRoute />}
                    >
                        {
                            routes
                                .map((route: any, index: number) => {
                                    if((roles && roles.length && typeof permissions == 'object') &&checkMatch(roles, route.role) || checkMatch(permissions, route.permissions)) {
                                         return <Route path={route.path} element={route.element} key={index} />
                                    }

                                    return (
                                        <Route path={route.path} element={<Unauthorized />} key={route.path} />
                                    )

                                }
                                )
                        }
                        <Route path={PageRoutes.DASHBOARD} element={<Dashboard />} />


                        <Route path="/short-courses" element={<ShortCourseIndex />}>
                            <Route index element={<ShortCourses />} />
                        </Route>


                        <Route path="/short-courses-order" element={<ShortCourseOrderIndex />}>
                            <Route index element={<ShortCoursesOrder />} />
                            <Route path=":id" element={<ShortCourseOrderDetail />} />
                            <Route path="pdf" element={<ShortCoursePdf />} />
                        </Route>

                        <Route path="/courses" element={<CourseIndex />}>
                            <Route index element={<Courses />} />
                            <Route path="new" element={<NewCourse />} />
                            <Route path="update/:id" element={<UpdateCourse />} />
                        </Route>

                        <Route path="/tickets" element={<TicketIndex />}>
                            <Route index element={<Tickets />} />
                            <Route path=":id" element={<TicketDetail />} />
                        </Route>

                        <Route path={PageRoutes.USERPROFILE} element={<UserProfile />} />

                        <Route path="/chat" element={<ChatIndex />}>
                            <Route index element={<ChatDashboard />} />
                            <Route path="chatbox" element={<ChatBox />} />
                            <Route path="guest" element={<GuestChatBox />} />
                        </Route>

                        <Route path="/users" element={<UserIndex />}>
                            <Route index element={<Users />} />
                            <Route path="profile" element={<UserProfile />} />
                            <Route path="update/:id" element={<UpdateUsers />} />
                            <Route path="change-password/:id" element={<ChangeUserPassword />} />
                        </Route>

                        {/* <Route path={PageRoutes.NEWUSER} element={<AddNewUser />} /> */}

                        <Route path={PageRoutes.APPLICATION} element={<ApplicationIndex />}>
                            <Route index element={<Application />} />
                            <Route path={PageRoutes.NEW} element={<NewApplication />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.APPLICATIONFORM} element={<ApplicationForm />} />
                            <Route path={PageRoutes.NEW} element={<NewApplication />} />
                            <Route path={PageRoutes.APPLICATIONEDIT} element={<EditApplication />} />
                        </Route>

                        <Route path={PageRoutes.APPLICATION} element={<Application />} />
                        <Route path={PageRoutes.APPLICATION + "/:formId"} element={<ApplicationFormDetails />} />
                        <Route path={PageRoutes.APPLICATION + "/:formId/pdf"} element={<ApplicationFormDetails />} />

                        <Route path={PageRoutes.ENROLLMENT} element={<EnrollmentIndex />}>
                            <Route index element={<Enrollment />} />
                            <Route path={PageRoutes.NEW} element={<NewEnrollment />} />
                            <Route path={PageRoutes.ENROLLMENTEDIT} element={<EditEnrollment />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.ENROLLMENTFORM} element={<EnrollmentForm />} />
                        </Route>

                        <Route path={PageRoutes.ENROLLMENT} element={<Enrollment />} />


                        {/* re-enrollment form route */}
                        <Route path={PageRoutes.REENROLLMENT} element={<ReEnrollmentIndex />}>
                            <Route index element={<ReEnrollment />} />
                            <Route path={PageRoutes.NEW} element={<ReEnrollmentWelcome />} />
                            <Route path={PageRoutes.REENROLLMENTEDIT} element={<EditReEnrollmentForm />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.REENROLLMENTFORM} element={<NewReEnrollmentForm />} />
                            <Route path={PageRoutes.REENROLLMENT + "/:formId/pdf"} element={<ReEnrollmentFormDetails />} />
                        </Route>
                        <Route path={PageRoutes.CHANGEOFADDRESS} element={<ChangeOfAddressIndex />}>
                            <Route index element={<ChangeOfAddress />} />
                            <Route path={PageRoutes.CHANGEOFADDRESSEDIT} element={<EditChangeOfAddressForm />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.CHANGEOFADDRESSFORM} element={<NewChangeOfAddressForm />} />
                            <Route path={PageRoutes.CHANGEOFADDRESS + "/:formId/pdf"} element={<ChangeOfAddressFormDetails />} />
                        </Route>
                        <Route path={PageRoutes.VARIATIONOFCOURSE} element={<VariationOfCourseIndex />}>
                            <Route index element={<VariationOfCourse />} />
                            <Route path={PageRoutes.VARIATIONOFCOURSEEDIT} element={<EditVariationOfCourseForm />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.VARIATIONOFCOURSEFORM} element={<NewVariationOfCourseForm />} />
                            <Route path={PageRoutes.VARIATIONOFCOURSE + "/:formId/pdf"} element={<VariationOfCourseFormDetails />} />
                        </Route>

                        <Route path={PageRoutes.INTERNALTRANSFER} element={<InternalTransferIndex />}>
                            <Route index element={<InternalTransfer />} />
                            <Route path={PageRoutes.INTERNALTRANSFEREDIT} element={<EditInternalTransferForm />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.INTERNALTRANSFERFORM} element={<NewInternalTransferForm />} />
                            <Route path={PageRoutes.INTERNALTRANSFER + "/:formId/pdf"} element={<InternalTransferFormDetails />} />
                        </Route>

                        <Route path={PageRoutes.STUDENTINTERVENTION} element={<StudentInterventionIndex />}>
                            <Route index element={<StudentIntervention />} />
                            <Route path={PageRoutes.STUDENTINTERVENTIONEDIT} element={<EditStudentInterventionForm />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.STUDENTINTERVENTIONFORM} element={<NewStudentInterventionForm />} />
                            <Route path={PageRoutes.STUDENTINTERVENTION + "/:formId/pdf"} element={<StudentInterventionDetails />} />
                        </Route>

                        <Route path={PageRoutes.REQUESTOFINFORMATION} element={<RequestOfInformationIndex />}>
                            <Route index element={<RequestOfInformation />} />
                            <Route path={PageRoutes.REQUESTOFINFORMATIONEDIT} element={<EditRequestOfInformationForm />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.REQUESTOFINFORMATIONFORM} element={<NewRequestOfInformationForm />} />
                            <Route path={PageRoutes.REQUESTOFINFORMATION + "/:formId/pdf"} element={<RequestOfInformationDetails />} />
                        </Route>

                        <Route path={PageRoutes.CREDITTRANSFER} element={<CreditTransferIndex />}>
                            <Route index element={<CreditTransfer />} />
                            <Route path={PageRoutes.CREDITTRANSFEREDIT} element={<EditCreditTransferForm />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.CREDITTRANSFERFORM} element={<NewCreditTransferForm />} />
                            <Route path={PageRoutes.CREDITTRANSFER + "/:formId/pdf"} element={<CreditTransferDetails />} />
                        </Route>

                        <Route path={PageRoutes.DSRCENROLMENT} element={<DSRCEnrolmentIndex />}>
                            <Route index element={<DSRCEnrolment />} />
                            <Route path={PageRoutes.DSRCENROLMENTEDIT} element={<EditDSRCEnrolmentForm />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.DSRCENROLMENTFORM} element={<NewDSRCEnrolmentForm />} />
                            <Route path={PageRoutes.DSRCENROLMENT + "/:formId/pdf"} element={<DSRCEnrolmentDetails />} />
                        </Route>

                        <Route path={PageRoutes.OVERSEASTRAVEL} element={<OverseasTravelIndex />}>
                            <Route index element={<OverseasTravel />} />
                            <Route path={PageRoutes.OVERSEASTRAVELEDIT} element={<EditOverseasTravelForm />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.OVERSEASTRAVELFORM} element={<NewOverseasTravelForm />} />
                            <Route path={PageRoutes.OVERSEASTRAVEL + "/:formId/pdf"} element={<OverseasTravelDetails />} />
                        </Route>

                        <Route path={PageRoutes.CERTIFICATEAPPLICATION} element={<CertificateApplicationIndex />}>
                            <Route index element={<CertificateApplication />} />
                            <Route path={PageRoutes.CERTIFICATEAPPLICATIONEDIT} element={<EditCertificateApplicationForm />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.CERTIFICATEAPPLICATIONFORM} element={<NewCertificateApplicationForm />} />
                            <Route path={PageRoutes.CERTIFICATEAPPLICATION + "/:formId/pdf"} element={<CertificateApplicationDetails />} />
                        </Route>

                        <Route path={PageRoutes.COMPLAINTSAPPEALS} element={<ComplaintsAppealsIndex />}>
                            <Route index element={<ComplaintsAppeals />} />
                            <Route path={PageRoutes.COMPLAINTSAPPEALSEDIT} element={<EditComplaintsAppealsForm />} />
                            <Route path={PageRoutes.NEW + "/" + PageRoutes.COMPLAINTSAPPEALSFORM} element={<NewComplaintsAppealsForm />} />
                            <Route path={PageRoutes.COMPLAINTSAPPEALS + "/:formId/pdf"} element={<ComplaintsAppealsDetails />} />
                        </Route>

                        {/* 
                        <Route path={PageRoutes.V5ENROLLMENT} element={<EnrollmentV5Index />}>
                            <Route index element={<Enrollmentv5 />} />
                            <Route path={PageRoutes.V5ENROLLMENTEDIT} element={<EnrollmentFormv5 />} />
                            <Route path={PageRoutes.NEW} element={<EnrollmentFormv5 />} />
                        </Route> */}
                        <Route path={PageRoutes.V5ENROLLMENT} element={<Enrollment />} />

                        <Route path={PageRoutes.ENROLLMENT + "/:formId/pdf"} element={<EnrollmentFormDetails />} />

                        <Route path="/document-types" element={<DocumentTypeIndex />}>
                            <Route index element={<DocumentTypes />} />
                        </Route>

                        <Route path="/note-categories" element={<NoteCategoriesPage />} />
                        <Route path={PageRoutes.PURCHASE_ORDER} element={<Outlet />}>
                            <Route index element={<PurchaseOrder />} />
                            <Route path={'create'} element={<CreatePurchaseOrder />} />
                            <Route path={':inventoryId'} element={<PurchaseOrderDetail />} />
                            <Route path={':inventoryId/edit'} element={<EditPurchaseOrder />} />
                        </Route>
                        <Route path="/inventory-items" element={<InventoryItemOverview />} />
                        <Route path={PageRoutes.INVENTORIES} element={<Outlet />}>
                            <Route index element={<InventoriesPage />}/>
                            <Route index path={`create`} element={<CreateInventoryPage />}/>
                            <Route path={':inventoryId/edit'} element={<EditPurchaseOrder />} />
                            <Route path={`${PageRoutes.INVENTORIES}/:inventory/assign`} element={<AssignInventoryPage />} />
                            <Route path={`:inventory/dispose`} element={<InventoryDisposePage />} />
                        </Route>
                    </Route>
                </Routes>
            </Suspense>

            {!isAuthenticated && <GuestChatBox />}

            <FeedbackPopup
                isVisible={feedbackOpen}
                formType={feedbackFormType}
                onClose={closeFeedback}
            />

            <ToastContainer />
        </div>
    );
}

export default App;
